import React from "react";
import { DataWithPopover } from "src/app/nbsCockpit/components/nbsCockpitDataWithPopover";
import { amountFormatter, Formatter } from "src/app/shared/components/amount-formatter";
import { InfoHoverIcon } from "../components/itemDrilldownTable/editRequestAllLines/components/InfoHoverIcon";
import { TaxCalculationsPopup } from "../components/itemDrilldownTable/editRequestAllLines/components/TaxCalculationsPopup";
import _ from "lodash";

export function truncate(source, size) {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
}

export const hoverDetails = (item: any, hoverItem: any) => {
    return (
        <DataWithPopover
            item={item}
            hoverItem={hoverItem}
        />
    )
}



export const verifyAndGetVertexPayload = (itemsData: any, itemData: any, prData:any, type:any) => {
    
    let data = {status: false, payload: {}};
    const isVertexCallRealtedDataExist = itemsData.filter((item=>((item?.Potaxcode === 'I1' || item?.Taxcode === 'I1') && item?.PR_Deleted === "")));
    function pad(d) {
        return (d < 10) ? '0' + d.toString() : d.toString();
    }
    if(prData.POCompanyCode.substring(0, 2).toLocaleUpperCase() === 'US'){
        if(isVertexCallRealtedDataExist.length > 0){
            const date = new Date();
            const todayDate = `${date.getFullYear().toString()+pad(date.getMonth()+1)+date.getDate().toString()}`;
            const getflexibleCodeFields  = (item) => {
                console.log(item.PR_AccCategory)
                if(item.PR_AccCategory === 'K')
                    return {
                        flexibleCodeFields : [
                            { 
                                fieldId: "1", 
                                value: "6 Others Office supplies" 
                            }, 
                            {
                                fieldId: "11", 
                                value: item?.VerCCCat ? item.VerCCCat.charAt(0) : ""
                            }
                        ]
                    }
                else if(item.PR_AccCategory === "P")
                    return {
                        flexibleCodeFields : [
                            { 
                                fieldId: "1", 
                                value: "6 Others Office supplies" 
                            },
                            {
                                fieldId: "13", 
                                value: (item?.VerCCCat && item.VerCCCat !== "") ? item.VerCCCat.charAt(0) : (item?.VerCostObject && item?.VerCostObject !== "") ? item.VerCostObject : "00"
                            }
                        ]
                    }
                else if(item.PR_AccCategory === "2")
                    return {
                        flexibleCodeFields : [
                            { 
                                fieldId: "1", 
                                value: "6 Others Office supplies" 
                            }
                        ]
                    }
                else if(item.PR_AccCategory === "")
                    return {
                        flexibleCodeFields : [
                            { 
                                fieldId: "1", 
                                value: "6 Others Office supplies" 
                            },
                            {
                                fieldId: "12", 
                                value: item?.MaterialType ? item.MaterialType : ""
                            }
                        ]
                    }
                else
                    return {
                        flexibleCodeFields : [
                            { 
                                fieldId: "1", 
                                value: "6 Others Office supplies" 
                            },
                            {
                                fieldId: "13", 
                                value:  item?.VerCostObject ? item.VerCostObject : ""
                            }
                        ]
                    }
            }
            const lineItems = isVertexCallRealtedDataExist.map((item)=>{
                if(item?.Pr_CostCenter && item.Pr_CostCenter !== ""){
                    console.log("Cost")
                    return {
                        lineItemNumber: item.PrItem,
                        taxDate: Number(todayDate),
                        costCenter: item.Pr_CostCenter,
                        generalLedgerAccount: item.Pr_GlAccount,
                        extendedPrice: amountFormatter(item.PrPrice, type).replace(/,/g,""),
                        purchase: {
                            value: item?.MatTaxCode ? item.MatTaxCode : ""
                        },
                        quantity: {
                            unitOfMeasure: item?.PrQuantityUom !== "" ? item?.PrQuantityUom : prData.Currency,
                            value: amountFormatter(item.PrQuantity, type).replace(/,/g,"")
                        },
                        flexibleFields: getflexibleCodeFields(item)
                    }
                }else if(item?.Pr_wbsid && item.Pr_wbsid !== ""){
                    console.log("Project")
                    return {
                        lineItemNumber: item.PrItem,
                        taxDate: Number(todayDate),
                        generalLedgerAccount: item.Pr_GlAccount,
                        projectNumber: item.Pr_wbsid,
                        extendedPrice: amountFormatter(item.PrPrice, type).replace(/,/g,""),
                        purchase: {
                            value: item?.MatTaxCode ? item.MatTaxCode : ""
                        },
                        quantity: {
                            unitOfMeasure: item?.PrQuantityUom !== "" ? item?.PrQuantityUom : prData.Currency,
                            value: amountFormatter(item.PrQuantity, type).replace(/,/g,"")
                        },
                        flexibleFields: getflexibleCodeFields(item)
                    }
                }else{
                    console.log("other")
                    return {
                        lineItemNumber: item.PrItem,
                        taxDate: Number(todayDate),
                        extendedPrice: amountFormatter(item.PrPrice, type).replace(/,/g,""),
                        purchase: {
                            value: item?.MatTaxCode ? item.MatTaxCode : ""
                        },
                        quantity: {
                            unitOfMeasure: item?.PrQuantityUom !== "" ? item?.PrQuantityUom : prData.Currency,
                            value: amountFormatter(item.PrQuantity, type).replace(/,/g,"")
                        },
                        flexibleFields: getflexibleCodeFields(item)
                    }
                }
            });
            console.log(itemData)
            const payload = {
                purchaseMessageType: "PURCHASE_ORDER",
                documentNumber: itemData.PrNo,
                orderType: "easyreq",
                locationCode: itemData.Plant,
                // documentDate: todayDate,
                // documentDate: "",
                transactionType: "PURCHASE",
                deliveryTerm: "SUP",
                buyer:{
                    company: "Nestle",
                    division: itemData?.CompCode !== "" ? itemData?.CompCode : prData.POCompanyCode,
                    destination:{
                        // streetAddress1: itemData?.Street ? itemData?.Street : "Street",
                        // city: itemData.City,
                        // mainDivision: itemData.Region,
                        // postalCode: itemData.Postalcode,
                        country: "US"
                    }
                },
                vendor:{
                    vendorCode:{
                        value: Number(itemData.Supplier).toString()
                    }
                    // administrativeOrigin:{
                    //     streetAddress1: itemData?.VendStreet ? itemData.VendStreet : (itemData?.Street ? itemData?.Street : "Street"),
                    //     city: itemData?.VendCity ? itemData.VendCity : itemData.City,
                    //     mainDivision: itemData?.VendRegion ? itemData.VendRegion.split('-')[0] : itemData.Region,
                    //     postalCode: itemData?.VendPostCode ? itemData.VendPostCode : itemData.Postalcode,
                    //     country: itemData?.VendCountry ? itemData.VendCountry.split('-')[0] : itemData.Country
                    // },
                    // physicalOrigin:{
                    //     streetAddress1: itemData?.Street ? itemData?.Street : "Street",
                    //     city: itemData.City,
                    //     mainDivision: itemData.Region,
                    //     postalCode: itemData.Postalcode,
                    //     country: itemData.Country
                    // }
                },
                lineItems:lineItems
            }
            return {status: true, payload: payload}
        }
        return data
    }
    return data;
}

export const showAmountOrAmountWithIcon = (item,data) => {
    if(!data.loading && !_.isEmpty(data.data)){
        const newData = data?.data?.data;
        const itemExist = newData?.lineItems?.filter((record)=>item.PrItem == record.lineItemNumber);
        if(itemExist.length>0 && itemExist.length===1){
            return <div style={{display:"flex", gap:"3px"}}><Formatter amount={item.PrPrice} /><InfoHoverIcon popUpComponent={<TaxCalculationsPopup itemAmount={item} taxAmount={itemExist[0]} />} /></div> 
        }else{
            return <Formatter amount={item.PrPrice} />
        }
    }else{
        return <Formatter amount={item.PrPrice} />
    }
}



